import { createListenerMiddleware } from '@reduxjs/toolkit';
import { loadSessionAction } from './actions';
import { getWsManager } from '../storeRef';

/**
 * Invalidate peer browsing contexts on session load.
 */
export const invalidatePeerOnLoad = createListenerMiddleware();
invalidatePeerOnLoad.startListening({
  actionCreator: loadSessionAction,
  effect: async action => {
    getWsManager().post_session_orchestration_message({ type: action.type });
  },
});
